import React, { Component } from 'react';
import { PickSummaryView } from './PickSummary/componentChildren/PickSummaryView';

import './PickSummary/css/PickSummary.css'
import { DialogMessage } from './Widgets/DialogMessage';
import { Loader } from './Widgets/Loader';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './css/Confirm.css';

export default class PickSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            summaryActive: false,
            userInput: '',
            pickingSummary: {},
            showDialog: false,
            isErrorMessage: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            loading: false
        };
        this.resetState = this.resetState.bind(this);
        this.showConfirm = this.showConfirm.bind(this);
        this.submitPickingSummaryEdit = this.submitPickingSummaryEdit.bind(this);
        this.billOrderConfirm = this.billOrderConfirm.bind(this);
        this.submitPickingSummaryEditCallback = this.submitPickingSummaryEditCallback.bind(this);
        this.updatePickSummaryQty = this.updatePickSummaryQty.bind(this);
        this.updateCancelled = this.updateCancelled.bind(this);
        this.updateBackordered = this.updateBackordered.bind(this);
        this.editAdditionalInfoField = this.editAdditionalInfoField.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.startLoading = this.startLoading.bind(this);
        this.stopLoading = this.stopLoading.bind(this);
        this.displayError = this.displayError.bind(this);
        this.lookupOrder = this.lookupOrder.bind(this);
        this.lookupOrderCallback = this.lookupOrderCallback.bind(this);
        this.focusOnInput = this.focusOnInput.bind(this);
        this.updateInputValue = this.updateInputValue.bind(this);
        
    }

    resetState() {
        this.setState({
            summaryActive: false,
            userInput: '',
            sopPickSummary: {},
            showDialog: false,
            isErrorMessage: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            loading: false
        });
    }

    showConfirm(title, message, buttonTextPositive, buttonTextNegative, positiveFunction, negativeFunction, hideSubmit = false) {
        var buttons = [{
            label: buttonTextNegative,
            onClick: negativeFunction
        }];
        if (!hideSubmit) {
            buttons.push({
                label: buttonTextPositive,
                onClick: positiveFunction
            });
        }

        const options = {
            title: title,
            message: message,
            buttons: buttons,
            childrenElement: () => <div />,
            closeOnEscape: false,
            closeOnClickOutside: false,
            willUnmount: () => { },
            afterClose: () => { },
            onClickOutside: () => { },
            onKeypressEscape: () => { },
            overlayClassName: "confirm-message"
        };

        confirmAlert(options);
    }

    submitPickingSummaryEdit() {
        this.showConfirm(
            "Bill and Ship Order",
            "Would you like to bill and ship this order?",
            "Finish Picking Later",
            "Bill and Ship",
            () => this.submitPickingSummaryEditCallback(false),
            () => setTimeout(this.billOrderConfirm,100)
        );
    }

    billOrderConfirm() {
        this.showConfirm(
            "Are you Sure?",
            "This order will be marked for billing",
            "Finish Picking Later",
            "Bill and Ship",
            () => this.submitPickingSummaryEditCallback(false),
            () => this.submitPickingSummaryEditCallback(true)
        );
    }

    async submitPickingSummaryEditCallback(readyToBill) {
        this.startLoading();
        var pickingSummary = this.state.pickingSummary;
        var backorderedLines = [];
        var cancelledLines = [];
        var modifiedQtys = {};
        var additionalInfoFields = {};
        var itemsToBeProcessed = pickingSummary.itemsToBeProcessed;
        var additionalInfo = pickingSummary.additionalInfo;
        for (var item in itemsToBeProcessed) {
            var lineUniqueId = itemsToBeProcessed[item].lineUniqueId;
            var isBackordered = itemsToBeProcessed[item].isBackordered;
            if (isBackordered) {
                backorderedLines.push(lineUniqueId);
            }
            var isCancelled = itemsToBeProcessed[item].cancelRemaining;
            if (isCancelled) {
                cancelledLines.push(lineUniqueId);
            }
            var inventoryDetailDict = {};
            for (var i in itemsToBeProcessed[item].inventoryDetailArray) {
                var binInfo = itemsToBeProcessed[item].inventoryDetailArray[i];
                inventoryDetailDict[binInfo.binId] = binInfo.qty;
            }
            modifiedQtys[lineUniqueId] = {
                qty: itemsToBeProcessed[item].qty,
                inventoryDetailDict: inventoryDetailDict
            };
        }
        for (var itemInfo in additionalInfo) {
            var lineUniqueId = additionalInfo[itemInfo].lineUniqueId;
            var newValue = additionalInfo[itemInfo].value;
            additionalInfoFields[lineUniqueId] = newValue;
        }
        var putBody = {
            SOPId: pickingSummary.SOPId,
            backorderedLines: backorderedLines,
            cancelledLines: cancelledLines,
            modifiedQtys: modifiedQtys,
            additionalInfoFields: additionalInfoFields,
            readyToBill: readyToBill
        }





        await this.props.makeRESTCall(
            'byuwmssoppicksummary',
            'put',
            putBody,
            (submitSummaryEditData) => {
                if (submitSummaryEditData.success) {
                    this.setState({
                        dialogContent: "The SO has been updated and marked for processing",
                        dialogTitle: "Order Updated Successfully",
                        showDialog: true,
                        isErrorMessage: false,
                        loading: false,
                        userInput: '',
                        pickingSummary: {},
                        summaryActive: false
                    });
                } else {
                    this.displayError("Unable to submit", "There was an error submitting; Please contact I.T.")
                }
            },
            (title, error) => {
               this.displayError(title, error);
            },
            () => {
                this.stopLoading();
            }
        );
    }

    updatePickSummaryQty(e, lineUniqueId, bin) {
        var newQty = e.target.value;
        var validInputRegex = RegExp("(^$|^[0-9]*$)");
        if (validInputRegex.test(newQty)) {
            var pickingSummary = this.state.pickingSummary;
            var itemsToBeProcessed = pickingSummary.itemsToBeProcessed;
            for (var i in itemsToBeProcessed) {
                var item = itemsToBeProcessed[i];
                //Null bins will be equal if it doesn't use bins
                if (item.lineUniqueId == lineUniqueId) {
                    if (item.inventoryDetailArray.length > 0) {
                        for (var j in item.inventoryDetailArray) {
                            var binInfo = item.inventoryDetailArray[j];
                            if (binInfo.bin == bin) {
                                var adjustment = binInfo.qty - newQty;
                                binInfo.qty = newQty;
                                item.inventoryDetailArray[j] = binInfo;
                                item.qty = item.qty - adjustment;
                                break;
                            }
                        }
                    }
                    else {
                        item.qty = newQty;
                    }
                    itemsToBeProcessed[i] = item;
                    pickingSummary.itemsToBeProcessed = itemsToBeProcessed;
                    this.setState({
                        pickingSummary: pickingSummary
                    });
                    break;
                }
            }
        }
    }

    updateCancelled(e, lineUniqueId) {
        var cancelRemaining = e.target.checked;
        var pickingSummary = this.state.pickingSummary;
        var itemsToBeProcessed = pickingSummary.itemsToBeProcessed;
        for (var i in itemsToBeProcessed) {
            var item = itemsToBeProcessed[i];
            if (item.lineUniqueId == lineUniqueId) {
                item.cancelRemaining = cancelRemaining;
                itemsToBeProcessed[i] = item;
                pickingSummary.itemsToBeProcessed = itemsToBeProcessed;
                this.setState({
                    pickingSummary: pickingSummary
                });
                break;
            }
        }
    }

    updateBackordered(e, lineUniqueId) {
        var backorderItem = e.target.checked;
        var pickingSummary = this.state.pickingSummary;
        var itemsToBeProcessed = pickingSummary.itemsToBeProcessed;
        for (var i in itemsToBeProcessed) {
            var item = itemsToBeProcessed[i];
            if (item.lineUniqueId == lineUniqueId) {
                item.isBackordered = backorderItem;
                itemsToBeProcessed[i] = item;
                pickingSummary.itemsToBeProcessed = itemsToBeProcessed;
                this.setState({
                    pickingSummary: pickingSummary
                });
                break;
            }
        }
    }

    editAdditionalInfoField(e, fieldId, lineUniqueId) {
        var newValue = e.target.value;
        var pickingSummary = this.state.pickingSummary;
        var additionalInfo = pickingSummary.additionalInfo;
        for (var i in additionalInfo) {
            if (additionalInfo[i].lineUniqueId == lineUniqueId && additionalInfo[i].fieldId == fieldId) {
                additionalInfo[i].value = newValue;
                pickingSummary.additionalInfo = additionalInfo;
                this.setState({
                    pickingSummary: pickingSummary
                });
                break;
            }
        }
    }


    closeDialog() {
        this.setState({
            showDialog: false,
            dialogFullScreen: false,
            dialogContent: "",
            dialogTitle: "",
            isErrorMessage: false
        });
        this.focusOnInput();
    }

    startLoading() {
        this.setState({
            loading: true
        });
    }

    stopLoading() {
        this.setState({
            loading: false
        });
    }

    displayError(title, message) {
        this.setState({
            dialogContent: message,
            dialogTitle: title,
            showDialog: true,
            isErrorMessage: true,
            actionDialog: false
        });
    }

    lookupOrder(e) {
        e.preventDefault();
        this.setState({
            loading: true
        });
        this.lookupOrderCallback();
    }


    async lookupOrderCallback() {
        await this.props.makeRESTCall(
            'byuwmssoppicksummary?recordNum=' + this.state.userInput,
            'get',
            null,
            (pickingSummaryResponse) => {
                if (pickingSummaryResponse.success) {
                    this.setState({
                        pickingSummary: pickingSummaryResponse.pickingSummary,
                        summaryActive: true,
                        loading: false,
                        userInput: ''
                    });
                    this.focusOnInput();
                }
                else {
                    this.setState({
                        dialogContent: pickingSummaryResponse.message,
                        dialogTitle: "Unable to look up order",
                        showDialog: true,
                        summaryActive: false,
                        isErrorMessage: false,
                        userInput: '',
                        loading: false
                    });
                }
            },
            (title, error) => {
                this.displayError(title, error);
            },
            () => {
                this.stopLoading();
            }
        );
    }

    focusOnInput() {
       document.getElementById("scanTote").focus();
    }

    updateInputValue(inputValue) {
        this.setState({
            userInput: inputValue.toUpperCase()
        });
    }

    render() {
        return (
            <div className="SOPPickSummary">
                <h1>WMS Pick Summary</h1>
                <DialogMessage
                    closeDialog={this.closeDialog}
                    showDialog={this.state.showDialog}
                    dialogTitle={this.state.dialogTitle}
                    dialogContent={this.state.dialogContent}
                    isErrorMessage={this.state.isErrorMessage}
                    dialogFullScreen={this.state.dialogFullScreen}
                />
                {
                    this.state.loading && <Loader />
                }
                <div>
                    <form action="#">
                        <h3 className='title'>Scan Tote ID or SO</h3>
                        <input autoComplete="off" id="scanTote" autoFocus name="scanTote" value={this.state.userInput} onChange={(event) => this.updateInputValue(event.target.value)}></input>
                        <button onClick={this.lookupOrder} className='submit'>Submit</button>
                    </form>
                </div>
                {
                    this.state.summaryActive
                    &&
                    <PickSummaryView
                        pickingSummary={this.state.pickingSummary}
                        canEditSummary={this.props.userPermissions.indexOf(this.props.appPermissions.EDIT_PICK_SUMMARY) > -1}
                        submitPickingSummaryEdit={this.submitPickingSummaryEdit}
                        updatePickSummaryQty={this.updatePickSummaryQty}
                        editAdditionalInfoField={this.editAdditionalInfoField}
                        updateBackordered={this.updateBackordered}
                        updateCancelled={this.updateCancelled}
                        resetState={this.resetState}
                    />
                }
            </div>
        );
    }
}
